import { render, staticRenderFns } from "./PaymentTypes.vue?vue&type=template&id=770e899e&scoped=true"
import script from "./PaymentTypes.vue?vue&type=script&lang=js"
export * from "./PaymentTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770e899e",
  null
  
)

export default component.exports